import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  viewChild,
  inject,
} from '@angular/core';
import {Toast, ToastPackage, ToastrService} from 'ngx-toastr';
import {timer} from 'rxjs';

const TOAST_FOCUS_DELAY = 100;

@Component({
  selector: 'app-custom-toast',
  templateUrl: './custom-toast.component.html',
  styleUrls: ['custom-toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class CustomToastComponent extends Toast implements AfterViewInit, OnDestroy {
  toastPackage: ToastPackage;
  private cdr = inject(ChangeDetectorRef);

  lastFocusedElement = null;
  toastContent = viewChild<ElementRef>('toastContent');

  constructor() {
    const toastPackage = inject(ToastPackage);
    const toastService = inject(ToastrService);

    super(toastService, toastPackage);

    this.toastPackage = toastPackage;
  }

  get toastRole() {
    if (this.toastPackage.toastType === 'toast-success' || this.toastPackage.toastType === 'toast-info') {
      return 'status';
    } else if (this.toastPackage.toastType === 'toast-warning' || this.toastPackage.toastType === 'toast-error') {
      return 'alert';
    } else {
      return 'alert';
    }
  }

  ngAfterViewInit(): void {
    this.cdr.markForCheck();
    timer(TOAST_FOCUS_DELAY).subscribe(() => {
      if (this.toastContent().nativeElement) {
        this.lastFocusedElement = document.activeElement;
        this.toastContent().nativeElement.focus();
        this.cdr.markForCheck();
      }
    });
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.lastFocusedElement.focus();
  }
}
